export default __webpack_public_path__ + "static/media/tik-tok.42b1269b.svg";